export default __webpack_public_path__ + "static/media/4.9c487e5d.png";